<script lang="ts">
import { I3pService } from '../../../../services/i3p.service'

export default {
    name: 'EditButtonsBottomContent',
    props: {
        i3pService: { type: I3pService, required: true },
    },
    computed: {
        responsiveClass() {
            return this.$vuetify.display.smAndDown ? 'mb-2' : ''
        },
    },
}
</script>

<template>
    <template v-if="i3pService.currentEntity">
        <v-btn
            class="mr-2" variant="flat" size="small" color="primary" :class="responsiveClass"
            :loading="i3pService.isSaving"
            @click="i3pService.beforeSaveEntity()"
        >
            {{
                $translate(`${i3pService.currentEntity.translationKey}.${i3pService.currentEntityK && i3pService.currentEntityK !== i3pService.creationSlug ? 'edit' : 'add'}`)
            }}
        </v-btn>
        <v-btn
            variant="outlined" size="small" color="primary" :class="responsiveClass"
            @click="i3pService.cancelEditEntity()"
        >
            {{ $translate(`${i3pService.currentEntity.translationKey}.cancel`) }}
        </v-btn>
    </template>
</template>
